<template>
	<div class="site">
    <div slot="container">
      <div class="site.base-search">
        <el-input placeholder="请输入内容" v-model="paramsObj.keyword" class="input-with-select" @keyup.enter.native="search" clearable
        @clear="search" style="width:240px">
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
        <label>项目名称</label>
        <el-input v-model="paramsObj.projectName" placeholder="请输入项目名称"></el-input>
        <label>企业名称</label>
				<el-input v-model="paramsObj.enterprisesHistoryName	" placeholder="请输入企业名称"></el-input>
        <label>组织机构代码</label>
				<el-input v-model="paramsObj.organizationCode" placeholder="请输入组织机构代码"></el-input>
        <label>金融产品类型</label>
        <el-select style="width:140px" v-model="targetValue" clearable placeholder="全部" @change="search">
          <el-option v-for="item in fieldOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="site.table">
        <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="headerStyle">
					<el-table-column type="index" :index="(index) => {return index+ (paramsObj.page - 1) * paramsObj.pageSize + 1}" label="序号"
						align="center"></el-table-column>
					<el-table-column prop="investmentFirmsName" label="金融机构名称" align="center"></el-table-column>
          <el-table-column prop="name" label="产品名称" align="center"></el-table-column>
          <el-table-column prop="projectName" label="项目名称" align="center"></el-table-column>
          <el-table-column prop="enterprisesHistoryName" label="企业名称" align="center"></el-table-column>
          <el-table-column prop="location" label="所在地区" align="center"></el-table-column>
          <el-table-column label="行业" align="center" prop="industryName"></el-table-column>

          <el-table-column prop="productTypeName" label="金融产品类型" align="center"></el-table-column>
          <el-table-column prop="institutionsApprovalStatus" label="审核状态" align="center">
            <template slot-scope="scope">
							<div v-if="scope.row.institutionsApprovalStatus === 1">待审核</div>
							<div v-if="scope.row.institutionsApprovalStatus === 2">不通过</div>
							<div v-if="scope.row.institutionsApprovalStatus === 3">退回</div>
							<div v-if="scope.row.institutionsApprovalStatus === 4">通过</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
							<el-button class="mini_btn" type="text" size="mini" @click="handleDetail(scope.row, true)">详情</el-button>
							<el-button style="margin-bottom: 5px;" size="mini" @click="openSiteModal(scope.row, false)" v-if="scope.row.institutionsApprovalStatus === 1 && isFinance">编辑</el-button>

            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pagination">
          <div class="grid-content bg-purple-light">
						<el-pagination @current-change="handleCurrentChange" :hide-on-single-page="true" layout="total, prev, pager, next,jumper"
							:total="total" :current-page.sync="paramsObj.page" :page-size="paramsObj.pageSize"></el-pagination>
          </div>
        </div>
      </div>
    </div>

		<!-- 新增机构 -->
		<el-dialog :title="titleDialog" :visible.sync="dialogFormVisible"
		 :close-on-click-modal="false" @closed="is_submit = true" :append-to-body="true" class="site.dialog">
		 	<el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="140px">
				<div class="form-title">产品信息</div>
        <el-row>
          <el-row>
            <el-form-item label="产品名称" prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入产品名称" disabled></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="金融产品类型" prop="productTypeName">
              <el-input v-model="ruleForm.productTypeName" placeholder="请输入金融产品类型" disabled></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model="ruleForm.projectName" placeholder="请输入项目名称" disabled></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="拟融资金额" prop="intendedFinancingAmount">
          <el-input v-model="ruleForm.intendedFinancingAmount"
                type="number" placeholder="请输入拟融资金额"></el-input>
        </el-form-item>
          </el-row>
          <el-row>
        <el-form-item label="贷款期限" prop="financingTermId">
              <el-select
                v-model="ruleForm.financingTermId"
                placeholder="请选择融资期限"
                clearable
                @change="selectChange($event, financingTermList, 'financingTermName')"
              >
                <el-option
                  :label="item.label"
                  :value="item.id"
                  v-for="item in financingTermList"
                  :key="item.id"
                ></el-option>
              </el-select>
        </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="企业名称" prop="enterprisesHistoryName">
              <el-input v-model="ruleForm.enterprisesHistoryName" placeholder="请输入企业名称" disabled></el-input>
            </el-form-item>
          </el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="所在地区" prop="location">
								<el-input v-model="ruleForm.location" placeholder="请输入所在地区" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
        </el-row>
				<div class="form-title">企业信息</div>
				<el-row>
					<el-col :span="12">
						<el-form-item label="企业名称" prop="enterpriseName">
							<el-input v-model="ruleForm.enterpriseName" placeholder="请输入企业名称" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="组织机构代码" prop="organizationCode">
							<el-input
								v-model="ruleForm.organizationCode"
								placeholder="请输入组织机构代码"
								disabled
							></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="企业法人" prop="legalPerson">
							<el-input v-model="ruleForm.legalPerson" placeholder="请输入企业法人" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="联系方式" prop="legalPersonPhone">
							<el-input v-model="ruleForm.legalPersonPhone" placeholder="请输入联系方式" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="财务负责人" prop="financialLeader">
							<el-input v-model="ruleForm.financialLeader" placeholder="请输入联系方式" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="联系方式" prop="financialLeaderPhone">
							<el-input v-model="ruleForm.financialLeaderPhone" placeholder="请输入联系方式" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="联系人" prop="contactPerson">
							<el-input v-model="ruleForm.contactPerson" placeholder="请输入联系人" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="联系方式" prop="contactPersonPhone">
							<el-input v-model="ruleForm.contactPersonPhone" placeholder="请输入联系方式" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="成立时间" prop="establishDate">
							<el-input v-model="ruleForm.establishDate" placeholder="请输入成立时间" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="纳税地点" prop="taxLocation">
							<el-input v-model="ruleForm.taxLocation" placeholder="请输入纳税地点" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="注册地址" prop="registeredAddress">
							<el-input v-model="ruleForm.registeredAddress" placeholder="请输入注册地址" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="实际地址" prop="physicalAddress">
							<el-input v-model="ruleForm.physicalAddress" placeholder="请输入实际地址" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="主要经营产品" prop="mainProduct">
							<el-input
								v-model="ruleForm.mainProduct"
								placeholder="请填写主要经营产品"
								disabled
							></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="上年度末总资产" prop="lastYearTotalAssets">
							<el-input
								v-model="ruleForm.lastYearTotalAssets"
								placeholder="请填写上年度末总资产"
								disabled
							></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="上年度销售收入" prop="lastYearSalesRevenue">
							<el-input
								v-model="ruleForm.lastYearSalesRevenue"
								placeholder="请填写上年度销售收入"
								disabled
							></el-input>
						</el-form-item>
					</el-col>
				</el-row>
        <el-row :span="20">
          <el-col :span="24">
            <el-form-item label="自主知识产权数量" prop="independentRightCount">
              <el-input v-model="ruleForm.independentRightCount" placeholder="请填写自主知识产权数量" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="公司简介" prop="introduction">
              <el-input
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 6 }"
                  placeholder=" 请填写公司简介"
                  v-model="ruleForm.introduction"
                  disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
				<div class="form-title">审核信息</div>
				<!-- 审核信息开始 -->
				<el-row :span="20">
					<el-col :span="24">
						<el-form-item label="审核状态" prop="approvalStatus">
							<el-select v-model="ruleForm.approvalStatus" placeholder="请选择审核状态" :disabled="disabled">
								<el-option label="待审核" :value="1"></el-option>
								<el-option label="不通过" :value="2"></el-option>
								<el-option label="退回" :value="3"></el-option>
								<el-option label="通过" :value="4"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="审核意见" prop="auditOpinion">
							<el-input v-model="ruleForm.auditOpinion" placeholder="请填写审核意见" :disabled="disabled"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :span="20">
					<el-col :span="24">
						<el-form-item label="附件上传" prop="fileList">
							<el-upload class="upload-demo" :action="this.uploadURL" style="text-align: left;" :before-upload="beforeAvatarUpload" :disabled="disabled"
								:on-remove="(file, fileList)=>handleRemove(file, fileList,'fileList')" :file-list="fileList" :on-success="(response, file, fileList) => handleAvatarSuccess(response, file, fileList,'fileList')"
								list-type="picture">
									<el-button size="small" type="primary" :disabled="disabled">上传附件材料</el-button>
								</el-upload>
						</el-form-item>
					</el-col>
				</el-row>
      </el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="createSite" v-if="operationType !== 'detail'">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import InputNumberRange from "../../../components/inputNumberRange"
	export default {
		components: {
			InputNumberRange
		},
		data() {
			return {
				disabled: false,
				titleDialog: "",
				listUrl: `${urlConfig.devUrl}apij2/admin-api/finance/product-apply/page`,
				targetValue: "",
				fieldOptions: [],
				financeRange: [], // 融资额度数组
				numberRange: [],
				productSuitableArr: [], // 覆盖地域
				is_submit: true,
				image: "",
				fileList: [],
				headerStyle: {
					color: "#623AA2",
					background: "#E5F3FE",
				},
				paramsObj: {
					keyword: "",
					page: 1,
					pageSize: 10,
					projectName: "", // 项目名称
					organizationCode: "", // 组织机构代码
					location: "", // 所在地区
					productTypeId: null, //	金融产品类型id
					enterprisesHistoryName: "", //	企业快照名称
				},
      financingTermList: [],
				operationType: "add",
				total: 20,
				dialogFormVisible: false,
				ruleForm: {
					name: '', // 产品名称
					industryId: '', // 行业id
					industryName: '', // 行业名称
					productSuitableJson: '', // 覆盖地域json
					introduction: '', // 产品简介
					features: '', // 功能特点
					handleCondition: '', // 办理条件
					applyProcess: '', // 申请流程
					financingAmountMin: '', // 融资额度最少
					financingAmountMax: '', // 融资额度最多
					annualizedRateMin: '', // 年化率最小
					annualizedRateMax: '', // 年化率最大
					financingTermId: "", // 融资期限id
					financingTermName: "", // 融资期限名称
					contactPerson: "", // 联系人
					contactInformation: "", // 联系方式
					approvalStatus: 1, // 审核状态
					returnStatus: "", // 是否为退回在提交:
					creatorCategory: "", // 创建者类别
					publishStatus: 1,  // 是否发布
					fileList: ""
				},
				rules: {
					// fileList: [
					// 	{ required: true, message: "请上传附件", trigger: ["blur", "change"] }
					// ],
					approvalStatus: [
						{ required: true, message: "请选择审核状态", trigger: ["blur", "change"] }
					],
					// auditOpinion: [
					// 	{ required: true, message: "请输入审核意见", trigger: "blur" }
					// ],
				},
				tableData: [],
			};
		},
		methods: {
    // 获取数据字典
    getGroup(row) {
      let obj = {
        dictTypes: ['financial_financing_term']
      };
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, obj).then(
        response => {
          if (response.code == 0) {
            this.financingTermList = response.data.financial_financing_term;
          } else {
            this.$message.error(response.status);
          }
        },
        error => {}
      );
    },
    
    selectChange(e, list, props) {
      if (e) {
        this.ruleForm[props] = list.find(item => item.id === e).label;
      } else {
        this.ruleForm[props] = '';
      }
      console.log('this.ruleForm[props]', this.ruleForm[props]);
    },
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 100;
				if (!isLt2M) {
					this.$message.error("上传文件大小不能超过 100MB!");
				}
				return isLt2M;
			},
			handleRemove(file, fileList, type) {
				this.fileList = fileList
				if(fileList.length === 0) {
					this.ruleForm.fileList = ""
				}else{
					this.ruleForm.fileList = JSON.stringify(fileList)
				}
			},
			handleAvatarSuccess(response, file, fileList, type) {
				if (response.code == 0) {
					this.fileList = fileList

					this.fileListChange(type);
				}
			},
			fileListChange(type) {
				let arr = [];
				if (this[type].length > 0) {
					this[type].map(item => {
						arr.push({
							url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
							name: item.name
						});
					});
					this.ruleForm[type] = JSON.stringify(arr);

					// if (type === 'logoSrc' || type === 'realImageSrc') {
					//   this.ruleForm[type] = arr[0].url;
					// }
				} else {
					this.ruleForm[type] = '';
					this[type] = [];
				}
			},
			// 确认添加机构
			createSite() {
				if (!this.is_submit) {
					return;
				}
				this.is_submit = false;
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						if (this.operationType == "add") {
							delete this.form.id;
							this.http.post("Meeting_Field", this.form).then((res) => {
								if (res.code == 0) {
									// this.ResetSearch(['searchValue'])

									this.$message.success("新建成功！");
									this.getData();
									this.dialogFormVisible = false;
								} else {
									this.is_submit = true;

									this.$message.error(res.status);
								}
							}).catch(err => {
								this.is_submit = true
							});
						} else {
							let obj = {
								approvalStatus: this.ruleForm.approvalStatus,
								auditOpinion: this.ruleForm.auditOpinion,
								fileList: this.ruleForm.fileList,
								productApplyId: this.ruleForm.id
							}
							this.http
							.post(`${urlConfig.devUrl}apij2/admin-api/finance/product-apply-record/approval`, obj)
								.then((res) => {
									if (res.code == 0) {
										// this.ResetSearch(['searchValue'])

										this.$message.success("编辑成功！");
										this.getData();
										this.dialogFormVisible = false;
									} else {
										this.is_submit = true;
										this.$message.error(res.status);
									}
								}).catch(err => {
									this.is_submit = true;
								});
						}
					} else {
						this.is_submit = true;

						console.log("error submit!!");
						return false;
					}
				});
			},
			// 新增
			openSiteModal(row, flag) {
				this.disabled = flag
				this.operationType = row ? "edit" : "add";
				this.dialogFormVisible = true;
				this.resetForm();

				if(this.operationType === "edit") {
					this.titleDialog = "编辑产品"
					this.getDetail(row)
				}
			},
			// 详情
			handleDetail(row) {
				this.disabled = true
				this.titleDialog = "产品详情"
				this.operationType = "detail";
				this.getDetail(row)
				this.disabled = true
				this.dialogFormVisible = true;
			},

			// 获取金融产品详情
			getDetail(row) {
				this.http.get(`${urlConfig.devUrl}apij2/admin-api/finance/product-apply/get?id=${row.id}`).then(
					(response) => {
						// this.ResetSearch(['searchValue'])

						if (response.code == 0) {
							console.log('response', response)
							this.ruleForm = response.data
							this.fileList = response.data.fileList ? JSON.parse(response.data.fileList) : []
							this.ruleForm.registeredAddress = this.ruleForm.registeredAddress ? JSON.parse(this.ruleForm.registeredAddress).join(' - ') + ' - ' + this.ruleForm.registeredAddressDetail : ""
							this.ruleForm.physicalAddress = this.ruleForm.physicalAddress ? JSON.parse(this.ruleForm.physicalAddress).join(' - ') + ' - ' + this.ruleForm.physicalAddressDetail : ""
						} else {
							this.$message.error(response.status);
						}
					},
					(error) => {}
				);
			},
			resetForm() {
				this.ruleForm = {
					name: '', // 产品名称
					industryId: '', // 行业id
					industryName: '', // 行业名称
					productSuitableJson: '', // 覆盖地域json
					introduction: '', // 产品简介
					features: '', // 功能特点
					handleCondition: '', // 办理条件
					applyProcess: '', // 申请流程
					financingAmountMin: '', // 融资额度最少
					financingAmountMax: '', // 融资额度最多
					annualizedRateMin: '', // 年化率最小
					annualizedRateMax: '', // 年化率最大
					financingTermId: "", // 融资期限id
					financingTermName: "", // 融资期限名称
					contactPerson: "", // 联系人
					contactInformation: "", // 联系方式
					approvalStatus: 1, // 审核状态
					returnStatus: "", // 是否为退回在提交:
					creatorCategory: "", // 创建者类别
					publishStatus: "",  // 是否发布
				}
			},
			//选择页码
			handleCurrentChange(e) {
				this.paramsObj.page = e;
				this.getData();
			},
			//搜索
			search() {
				this.getData();
			},
			getData() {
        this.paramsObj.organizationCode = this.paramsObj.organizationCode || null
        this.paramsObj.location = this.paramsObj.location || null
				this.http.post(this.listUrl, this.paramsObj).then((res) => {
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.total = res.data.total;
					}
				});
			},
		},
		mounted() {
			this.getData();
			this.getGroup();
		},
	};
</script>
<style lang="scss">
	@include component(site) {
		width: 100%;
		height: 100%;

		@include part(header) {
			display: flex;
			justify-content: flex-start;

			@include component(el-input) {
				width: 300px;
			}
		}

		@include part(searchBtn) {
			margin-left: 10px;
		}

		@include part(addBtn) {
			margin-right: 30px !important;
			background: #623aa2 !important;
			color: #fff;
			border: none;
		}

		@include part(table) {
			margin-top: 30px;
		}

		@include component(rowItem) {
			width: 50%;
		}

		@include component(el-radio-group) {
			width: 100%;
			text-align: left;
		}


    @include part(base-search){
			width: 100%;
			text-align: left;
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			align-items: center;

			label{
				margin-left: 20px;
			}

			/deep/.el-input--suffix {
				width: 100%;
			}

			.el-input {
				margin: 0 15px;
				width: auto;
			}

			.date-picker {
				margin: 0 15px;

				.el-range-separator {
					width: auto;
				}
			}
		}

		@include part(dialog) {
			.avatar-uploader .el-upload {
				border: 1px dashed #d9d9d9;
				border-radius: 6px;
				cursor: pointer;
				position: relative;
				overflow: hidden;
			}

			.avatar-uploader .el-upload:hover {
				border-color: #409eff;
			}

			.avatar-uploader-icon {
				font-size: 28px;
				color: #8c939d;
				width: 178px;
				height: 130px;
				line-height: 130px;
				text-align: center;
			}

			.avatar {
				width: 178px;
				height: 178px;
				display: block;
			}

			.el-radio-group {
				display: flex;
			}
			.el-select{
					width: 100%;
					margin: 0;
				}
			.upload_btn {
				display: block;
				background-color: #00a1ff;
				font-weight: bold;
				color: #fff;
				padding: 2px;
				border-bottom-left-radius: 3px;
				border-bottom-right-radius: 3px;
			}

			.el-radio {
				display: flex;
				align-items: center;
			}

			.imgInput {
				background: url(../../../assets/add.png) no-repeat;
				border: none;
				text-indent: -2000px;
				height: 120px;
				padding: 10px;
				background-size: 70%;
				background-position: center;
				color: white;
				cursor: pointer;
			}

			.imgInput:focus {
				border: none;
				outline: 0;
			}

			.allPics {
				border: 1px solid #ccc;
				padding: 18px 15px 10px 20px;
				width: 90%;
				margin: 0 auto;
				margin-bottom: 30px;
				position: relative;
				// display: flex;
				// flex-wrap: wrap;
				// justify-content: space-between;
			}

			.allPics1 {
				display: flex;
				// flex-wrap: wrap;
			}

			.addPic-body {
				padding: 10px;
				height: 120px;
			}

			.addPic-close {
				position: absolute;
				top: 10px;
				right: 10px;
			}

			.addPic {
				max-width: 100%;
				max-height: 100%;
			}

			.el-form-item__content {
				text-align: left;
			}

			.form-title {
				width: 100%;
				text-align: left;
				color: #623aa2;
				border-left: 5px solid #623aa2;
				border-bottom: 1px solid #623aa2;
				padding-left: 10px;
				font-size: 20px;
				margin-bottom: 20px;
				font-weight: 700;
			}
		}
		.rowItem1 {
			float: left;
		}
	}
</style>
